<template>
  <div class="card">
    <div class="card-header padding_12_20">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="me-3">
            <img src="@/assets/images/svg-img/generation.svg" />
          </div>
          <div>
            <div class="card_title_1">BUDGET</div>
            <div class="card_title_2">Last Updated {{ last_update }}</div>
          </div>
        </div>
        <div>
          <!-- <select class="form-select custom_select" style="color: #838383">
            <option value="all" selected>Select UID</option>
            <option>1111</option>
            <option>2222</option>
          </select> -->
          <select v-model="uuid" class="custom-dropdown form-select">
            <option
              v-for="(option, key) in dataUuid"
              :key="key"
              :value="option.value"
              :disabled="option.disabled"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-3">
          <CardBudgetInvestment
            v-if="dataBudget != null && dataBudget.investments.length > 0"
            :param="dataBudget.investments[0]"
            :selected="
              selectedCard.metricId === dataBudget.investments[0].metricId
            "
            @click="selectCard(dataBudget.investments[0])"
          ></CardBudgetInvestment>
        </div>
        <div class="col-3">
          <CardBudgetInvestment
            v-if="dataBudget != null && dataBudget.investments.length > 0"
            :param="dataBudget.investments[1]"
            :selected="
              selectedCard.metricId === dataBudget.investments[1].metricId
            "
            @click="selectCard(dataBudget.investments[1])"
          ></CardBudgetInvestment>
        </div>
        <div class="col-3">
          <CardBudgetInvestment
            v-if="dataBudget != null && dataBudget.investments.length > 0"
            :param="dataBudget.investments[2]"
            :selected="
              selectedCard.metricId === dataBudget.investments[2].metricId
            "
            @click="selectCard(dataBudget.investments[2])"
          ></CardBudgetInvestment>
        </div>
        <div class="col-3">
          <CardBudgetInvestment
            v-if="dataBudget != null && dataBudget.investments.length > 0"
            :param="dataBudget.investments[3]"
            :selected="
              selectedCard.metricId === dataBudget.investments[3].metricId
            "
            @click="selectCard(dataBudget.investments[3])"
          ></CardBudgetInvestment>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card card_white flex-fill" style="padding: 0px">
            <div class="row" style="--bs-gutter-x: 0px">
              <div class="col-4">
                <CardBudgetKpi
                  style="border-right: 1px solid #e6e6e6"
                  v-if="dataBudget != null && dataBudget.kpis.length > 0"
                  :param="dataBudget.kpis[0]"
                  :selected="
                    selectedCard.metricId === dataBudget.kpis[0].metricId
                  "
                  @click="selectCard(dataBudget.kpis[0])"
                ></CardBudgetKpi>
                <card-white-null v-else></card-white-null>
              </div>
              <div class="col-4">
                <CardBudgetKpi
                  style="border-right: 1px solid #e6e6e6"
                  v-if="dataBudget != null && dataBudget.kpis.length > 0"
                  :param="dataBudget.kpis[1]"
                  :selected="
                    selectedCard.metricId === dataBudget.kpis[1].metricId
                  "
                  @click="selectCard(dataBudget.kpis[1])"
                ></CardBudgetKpi>
                <card-white-null v-else></card-white-null>
              </div>
              <div class="col-4">
                <CardBudgetKpi
                  v-if="dataBudget != null && dataBudget.kpis.length > 0"
                  :param="dataBudget.kpis[2]"
                  :selected="
                    selectedCard.metricId === dataBudget.kpis[2].metricId
                  "
                  @click="selectCard(dataBudget.kpis[2])"
                ></CardBudgetKpi>
                <card-white-null v-else></card-white-null>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h5>{{ selectedCard.metricName }}</h5>
          <div class="d-flex justify-content-between">
            <div class="d-flex card-header-right">
              <div>
                <button
                  @click="monthly"
                  class="btn btn-square"
                  :class="{ 'btn-info': !isActiveMonth }"
                  type="button"
                  title="btn btn-square btn-disable btn-primary"
                >
                  Monthly
                </button>
                <button
                  @click="monthly"
                  :class="{ 'btn-info': isActiveMonth }"
                  class="btn btn-square btn-disable m-r-10"
                  type="button"
                  title="btn btn-square btn-primary"
                >
                  Cumulative
                </button>
              </div>
              <div>
                <select v-model="year" class="custom-dropdown form-select">
                  <option
                    v-for="(option, key) in dataYear"
                    :key="key"
                    :value="option.value"
                  >
                    {{ option.label }}
                  </option>
                  <!-- <option>Fix price</option> -->
                </select>
              </div>
            </div>
            <div class="text-end">
              <div class="d-flex">
                <div class="d-flex flex-row-reverse align-items-center m-r-10">
                  <div>
                    <input
                      class="form-check-input custom_checkbox_tarif"
                      type="checkbox"
                      v-model="isCheckedM"
                    />
                  </div>
                  <div class="custom_checkbox_texts">Material</div>
                </div>
                <div class="d-flex flex-row-reverse align-items-center m-r-10">
                  <div>
                    <input
                      class="form-check-input custom_checkbox_revenue"
                      type="checkbox"
                      v-model="isCheckedJ"
                    />
                  </div>
                  <div class="custom_checkbox_texts">Jasa</div>
                </div>
                <div class="checkbox-solid-primary">
                  <span class="custom_checkbox_texts">Budget</span>
                  <span style="color: red; font-weight: bold">......</span>
                </div>
              </div>
            </div>
          </div>
          <apexchart
            type="bar"
            height="350"
            :options="barChartOptions"
            :series="barSeries"
          ></apexchart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import DistributionService from "@/services/distribution/distribution";
import ReferenceService from "@/services/reference/reference";

import CardBudgetInvestment from "./CardBudgetInvestment.vue";
import CardBudgetKpi from "./CardBudgetKpi.vue";
import CardWhite from "./CardWhite.vue";
import CardWhiteNull from "./CardWhiteNull.vue";

const getRef = ReferenceService.build();
const apiDistribution = DistributionService.build();
export default {
  props: ["last_update", "data"],
  components: {
    IconSvg,
    CardBudgetInvestment,
    CardBudgetKpi,
    CardWhiteNull,
  },
  data() {
    return {
      uuid: "default",
      dataUuid: [],
      isCheckedM: true,
      isCheckedJ: true,
      year: "2024",
      dataYear: [
        { value: "2024", label: "2024" },
        { value: "2023", label: "2023" },
        { value: "2022", label: "2022" },
      ],
      isActiveMonth: false,
      barSeries: [],
      barChartOptions: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        stroke: {
          width: 1,
          colors: ["#cc9900"],
        },
        /*title: {
          text: "100% Stacked Bar",
        },*/
        xaxis: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "K";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "right",
          horizontalAlign: "left",
          offsetX: 40,
          show: true,
        },
      },
      dataBudget: null,
      dataBudgetDetail: null,
      selectedCard: 0,
    };
  },
  mounted() {
    this.getDataDistributionBudget("");
    this.getRefUid();
  },
  methods: {
    async getRefUid() {
      const res = await getRef.getRefUid();
      const data = res.data.data;
      const defaults = {
        label: "Select UID",
        value: "default",
        disabled: true,
      };
      this.dataUuid = data;
      this.dataUuid.push(defaults);
    },
    monthly() {
      this.isActiveMonth = !this.isActiveMonth;
    },
    selectCard(card) {
      this.selectedCard = card;
      let params = {
        id: card.metricId,
        year: "",
        type: "",
        instance: "",
      };

      this.getDataDistributionBudgetDetail(params);
    },

    updateSeries() {
      this.barSeries = this.dataBudgetDetail;
    },

    async getDataDistributionBudget(instance) {
      let param = Object.assign({
        instance: instance,
      });
      const res = await apiDistribution.getDataDistributionBudget(param);
      if (res && res.status == 200) {
        this.dataBudget = res.data.data;
        this.selectCard(res.data.data.investments[0]);
      }
    },

    async getDataDistributionBudgetDetail(params) {
      let param = Object.assign({
        id: params.id,
        year: params.year,
        type: params.type,
        instance: params.instance,
      });
      try {
        const res = await apiDistribution.getDataDistributionBudgetDetail(
          param
        );
        if (res && res.status == 200) {
          this.dataBudgetDetail = res.data.data;
          this.updateSeries();
        }
      } catch (error) {
        console.error("Error fetching data distribution budget detail:", error);
      }
    },
  },
};
</script>
